import React from 'react';
import styled from '@emotion/styled'
import { Grid } from 'style';
import { Spacer200, Spacer300 } from '..';
import ThoughtDetailsComponent from '../thoughtsList/subcomponents/thoughtDetails.component';

const ThoughtHeaderComponent = ({ title, image, date, timeToRead }) => {
  var date2 = new Date().getTime();
  var date1 = new Date(date).getTime();

  var diff = date2 - date1;

  var minutes = (diff / 1000) / 60;
  var hours = minutes / 60;
  var days = hours / 24;

  let dateString = date;
  if (days < 365) {
    dateString = dateString.split('.')[0];
  }
  return (
    <HeroFront id="ThoughtHeaderComponent">
      <Grid.InnerContainer>
        <Grid.RowThought>
          <Spacer300 />
          <HeroText>{title}</HeroText>
          <ThoughtDetailsComponent
            date={dateString}
            readTime={timeToRead}
            className="h2"
          />
          <Spacer200 />
        </Grid.RowThought>
      </Grid.InnerContainer>
    </HeroFront>
  );
};

const HeroText = styled.h1`
    white-space: pre-line;
    margin-bottom: 2rem;
    font-family: 'Tomoslab';
    font-weight: 100;
`;

const HeroFront = styled.div`
    width: 100%;
    height: 100%;
    align-items: center;
    z-index: 1;
`;
const ImageWrapper = styled.div`
    width: 100%;
    display: block;
`;

export default ThoughtHeaderComponent;
